import { Button, Container } from '@mui/material'
import React, { useContext } from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import { useCuestionario } from "../hooks/useCuestionario"
import FinalizarCuestionario from '../components/FinalizarCuestionario'
import { TooltipButton } from '../components/commons/TooltipButton'
import { useTranslation } from "react-i18next"
import { styled } from '@mui/material/styles'
import { EjesSkeleton } from '../components/commons/EjesSkeleton'
import { EjesContext } from '../context/EjesContext'
import { GeneralContext } from '../context/GeneralContext'
import { useContestaciones } from '../hooks/useContestaciones'
import { useState, useEffect } from 'react';
import { useUser } from '../hooks/useUser.jsx';
import { useNavigate } from 'react-router-dom';
import { DobleCircularProgressWithLabel } from '../components/commons/DobleCircularProgressWithLabel';
import { PercentageBarLabel } from '../components/commons/PercentageBarLabel';
import ReplayIcon from '@mui/icons-material/Replay';
import { Box, Stack } from '@mui/system';
import ModalConfirmar from '../components/commons/ModalConfirmar'
import "../styles/Ejes.css";
import Modal from '../components/commons/Modal'
import { ShowPerfilEmpresarial } from '../components/ShowPerfilEmpresarial'
import { RadarChart } from "../components/Radar.jsx"
import colors from '../theme/colors'
import { usePerfilEmpresarialActual } from '../hooks/perfilEmpresarial/usePerfilEmpresarialActual'
import { ObtenerInformesButtons } from '../components/ObtenerInformesButtons'
import { EjesPDFButtons } from '../components/EjesPDFButtons'
import { EjesFunctionButtons } from '../components/EjesFunctionButtons'
import { useSecurity } from "../hooks/useSecurity"

const IconButton = styled(Button)(({ theme }) => ({
    padding: '6px 6px',
    minWidth: '35px',
    height: '35px'
}));

export const Ejes = () => {
    const { getEjesCuestionario, anularEje, activarEje } = useCuestionario()
    const [listaEjes, setListaEjes] = useState()
    const { reiniciarEje } = useContestaciones()
    const { user } = useUser()
    const navigate = useNavigate()
    const { t } = useTranslation()
    const { handleOpenFinalizarCuestionario, loading, setLoading, GetCuestionarioReportEje, GetCuestionarioReportParcial } = useContext(EjesContext)
    const { setIdAxe, setQuestionaryPercentage } = useContext(GeneralContext)
    const [open, setOpen] = useState(false);
    const [showInfoModal, setShowInfoModal] = useState(false);
    const { perfilEmpresarial } = usePerfilEmpresarialActual();
    const [showPerfilEmpresarial, setShowPerfilEmpresarial] = useState(false);
    const { loadingModal, setLoadingModal } = useContext(GeneralContext);
    useSecurity();

    const handleClose = () => {
        setOpen(false);
        setShowPerfilEmpresarial(false)
    };

    function goToTema(axe) {
        setIdAxe(axe)
        navigate('/Cuestion')
    }
    function volverAMisCuestionarios() {
        navigate("/MisCuestionarios")
    }

    const handleShowInfoModal = () => {
        setShowInfoModal(true)
    }

    function reiniciarEjeFunction(idEje) {
        reiniciarEje(user, idEje)
            .then(
                (ejes) => {
                    setListaEjes(ejes)
                    console.log(ejes)
                    setLoadingModal(null)
                },
                (y) => {
                    console.error("Error: " + y)
                }
            );
    }


    function anularEjeFunction(idEje) {
        anularEje(user, idEje)
            .then(
                (ejes) => {
                    setListaEjes(ejes)
                    setLoadingModal(null)
                },
                (y) => {
                    console.error("Error: " + y)
                }

            );
    }

    function activarEjeFunction(idEje) {
        activarEje(user, idEje)
            .then(
                (ejes) => {
                    setListaEjes(ejes)
                    setLoadingModal(null)
                },
                (y) => {
                    console.error("Error: " + y)
                }
            );
    }

    useEffect(() => {

        user?.usuario &&
            getEjesCuestionario(user)
                .then(
                    (ejes) => {
                        setListaEjes({ ...ejes })
                        setQuestionaryPercentage(ejes.porcentajeCuestionario)
                    },
                    (promiseError) => {
                        if (promiseError.response && promiseError.response.status === 406) {
                            //NotAccepable - no se ha elegido modo de cuestionario
                            navigate("/seleccionar-modo-cuestionario");
                        } else if (promiseError.response?.status === 500) {
                            navigate("/misCuestionarios");
                        } else {
                            console.error(promiseError);
                        }
                    }
                );

    }, [user]);

    useEffect(() => {
        if (listaEjes && listaEjes.porcentajeCuestionario === 100) {
            setOpen(true);
        }
    }, [listaEjes])

    const [loadingStates, setLoadingStates] = useState({});

    const handlePdfClick = async (id_tema, eje) => {
        setLoadingStates(prev => ({ ...prev, [id_tema]: true }));

        setTimeout(() => {
            setLoadingStates(prev => ({ ...prev, [id_tema]: false }));
        }, 2000);
    };


    return (
        <Grid container
            direction="column"
            justifyContent="center"
        >
            <Box>
                <EjesFunctionButtons volverAMisCuestionarios={volverAMisCuestionarios} setShowPerfilEmpresarial={setShowPerfilEmpresarial} />
            </Box>

            <Modal
                title={t('crearPerfilEmpresarial.titulo')}
                content={<ShowPerfilEmpresarial perfilEmpresarial={perfilEmpresarial} />}
                open={showPerfilEmpresarial}
                close={handleClose}>
                <Button variant="contained" onClick={handleClose}>{t("general.cerrar")}</Button>
            </Modal>
            
            <Grid item xs={12} >
                <Typography variant='h1' margin={2}>{t("eje.titulo")}</Typography>
            </Grid>

            <Grid item className='ejesBody'>
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    spacing={2}
                    sx={{ width: "90%", margin: "0 auto" }}
                >
                    <Grid item xs={12} sx={{ marginBottom: "2em", textAlign: 'center' }}>
                        {listaEjes?.porcentajeCuestionario > 0 && (
                            <>
                                <Typography
                                    variant="h2"
                                    textAlign={"center"}
                                    marginBottom={2}
                                >
                                    {t("general.porcentajeTotal")}
                                </Typography>
                                <DobleCircularProgressWithLabel percentage={listaEjes.porcentajeCuestionario} size={120} fontSize={"1.5em"} />
                            </>
                        )}
                    </Grid>
                    {listaEjes ? (
                        <>
                            {listaEjes.ejes.map(eje =>
                                <Grid item xs={12} sm={6} lg={3} key={eje.id_eje}>
                                    <Card className='card' onClick={() => { goToTema(eje.id_eje) }}
                                        sx={{
                                            backgroundColor: eje.disable && colors.textMain,
                                            pointerEvents: eje.disable && "none",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: eje.porcentaje > 0 ? "space-around" : "center",
                                            minHeight: "250px",
                                            '&:hover': {
                                                cursor: 'pointer'
                                            },
                                            filter: eje.disable && "grayscale(1)"
                                        }} >
                                        <CardContent>
                                            <Box component={'img'} flex={1} src={require("../images/" + eje.key + ".png")} loading='lazy' alt={eje.key} />
                                            <Typography variant="h5" component="div" style={{ fontSize: '1.1em' }}>
                                                {eje.texto}
                                            </Typography>
                                        </CardContent>
                                        <Box marginBottom={"1em"} marginX={"1em"}>
                                            {eje.porcentaje > 0 && (
                                                <PercentageBarLabel altura={10} percentage={eje.porcentaje} />
                                            )}
                                        </Box>
                                    </Card>
                                    <Box>

                                        

                                        <EjesPDFButtons loading={loadingStates[eje.id_eje] || false}
                                            setLoading={(isLoading) => handlePdfClick(eje.id_eje, isLoading)} eje={eje} listaEjes={listaEjes} activarEjeFunction={activarEjeFunction} anularEjeFunction={anularEjeFunction} GetCuestionarioReportEje={GetCuestionarioReportEje} reiniciarEjeFunction={reiniciarEjeFunction} goToTema={goToTema} />
                                    </Box>
                                </Grid>
                            )}

                            <Grid
                                item
                                xs={12}
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginY: "3rem",
                                }}
                            >
                                <Stack spacing={2} direction="row">
                                    <ObtenerInformesButtons loading={loading} setLoading={setLoading} listaEjes={listaEjes} GetCuestionarioReportParcial={GetCuestionarioReportParcial} handleOpenFinalizarCuestionario={handleOpenFinalizarCuestionario} handleShowInfoModal={handleShowInfoModal}/>
                                </Stack>
                                {listaEjes?.porcentajeCuestionario === 100 && (
                                    <FinalizarCuestionario
                                        idCuestionario={listaEjes.id_cuestionario}
                                    />
                                )}
                            </Grid>
                            <Modal
                                title={t("eje.tituloObtenerInformeGlobal")}
                                content={t("eje.bodyObtenerInformeGlobal")}
                                open={showInfoModal}
                            >
                                <Button
                                    variant="contained"
                                    onClick={() => {
                                        setShowInfoModal(false);
                                    }}
                                >
                                    {t("general.aceptar")}
                                </Button>
                            </Modal>
                            <Modal
                                title={""}
                                content={t("eje.listaEjes100Modal")}
                                open={open}
                                close={handleClose}
                                center={true}
                            >
                                <Button variant="contained" onClick={handleClose}>{t("general.cerrar")}</Button>
                            </Modal>

                            {/*Este radar se crea en oculto para que salga en el pdf parcial */}
                            <Box sx={{
                                position: "absolute", zIndex: -99, height: { xs: 'auto', md: '550px' }, display: 'flex', alignContent: 'center', justifyContent: 'center'
                            }}>
                                <RadarChart puntuacionesEjes={listaEjes?.puntuacionEje?.length >= 3 ? listaEjes.puntuacionEje : null} calification={"B"} />
                            </Box>
                        </>
                    ) : (
                        <EjesSkeleton />
                    )}
                </Grid>
            </Grid>
        </Grid >
    )
}
